import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import About from "./pages/About";
import Contact from "./pages/Contact";
import BasicCalculator from "./pages/calculators/BasicCalculator";
import ScientificCalculator from "./pages/calculators/ScientificCalculator";
import EMICalculator from "./pages/calculators/EMICalculator";
import MortgageCalculator from "./pages/calculators/MortgageCalculator";
import BMICalculator from "./pages/calculators/BMICalculator";
import AgeCalculator from "./pages/calculators/AgeCalculator";
import PercentageCalculator from "./pages/calculators/PercentageCalculator";
import TipCalculator from "./pages/calculators/TipCalculator";
import DateCalculator from "./pages/calculators/DateCalculator";
import FractionCalculator from "./pages/calculators/FractionCalculator";
import SIPCalculator from "./pages/calculators/SIPCalculator";
import FDCalculator from "./pages/calculators/FDCalculator";
import PPFCalculator from "./pages/calculators/PPFCalculator";
import GSTCalculator from "./pages/calculators/GSTCalculator";
import IncomeTaxCalculator from "./pages/calculators/IncomeTaxCalculator";
import RetirementCalculator from "./pages/calculators/RetirementCalculator";
import BMRCalculator from "./pages/calculators/BMRCalculator";
import CalorieCalculator from "./pages/calculators/CalorieCalculator";
import BodyFatCalculator from "./pages/calculators/BodyFatCalculator";
import IdealWeightCalculator from "./pages/calculators/IdealWeightCalculator";
import PaceCalculator from "./pages/calculators/PaceCalculator";
import PregnancyCalculator from "./pages/calculators/PregnancyCalculator";
import DueDateCalculator from "./pages/calculators/DueDateCalculator";
import RatioCalculator from "./pages/calculators/RatioCalculator";
import ExponentCalculator from "./pages/calculators/ExponentCalculator";
import LogCalculator from "./pages/calculators/LogCalculator";
import MatrixCalculator from "./pages/calculators/MatrixCalculator";
import TimeCalculator from "./pages/calculators/TimeCalculator";
import HoursCalculator from "./pages/calculators/HoursCalculator";
import GradeCalculator from "./pages/calculators/GradeCalculator";
import GPACalculator from "./pages/calculators/GPACalculator";
import PasswordCalculator from "./pages/calculators/PasswordCalculator";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="min-h-[calc(100vh-180px)]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/calculator/basic" element={<BasicCalculator />} />
            <Route path="/calculator/scientific" element={<ScientificCalculator />} />
            <Route path="/calculator/emi" element={<EMICalculator />} />
            <Route path="/calculator/mortgage" element={<MortgageCalculator />} />
            <Route path="/calculator/bmi" element={<BMICalculator />} />
            <Route path="/calculator/age" element={<AgeCalculator />} />
            <Route path="/calculator/percentage" element={<PercentageCalculator />} />
            <Route path="/calculator/tip" element={<TipCalculator />} />
            <Route path="/calculator/date" element={<DateCalculator />} />
            <Route path="/calculator/fraction" element={<FractionCalculator />} />
            <Route path="/calculator/sip" element={<SIPCalculator />} />
            <Route path="/calculator/fd" element={<FDCalculator />} />
            <Route path="/calculator/ppf" element={<PPFCalculator />} />
            <Route path="/calculator/gst" element={<GSTCalculator />} />
            <Route path="/calculator/income-tax" element={<IncomeTaxCalculator />} />
            <Route path="/calculator/retirement" element={<RetirementCalculator />} />
            <Route path="/calculator/bmr" element={<BMRCalculator />} />
            <Route path="/calculator/calorie" element={<CalorieCalculator />} />
            <Route path="/calculator/body-fat" element={<BodyFatCalculator />} />
            <Route path="/calculator/ideal-weight" element={<IdealWeightCalculator />} />
            <Route path="/calculator/pace" element={<PaceCalculator />} />
            <Route path="/calculator/pregnancy" element={<PregnancyCalculator />} />
            <Route path="/calculator/due-date" element={<DueDateCalculator />} />
            <Route path="/calculator/ratio" element={<RatioCalculator />} />
            <Route path="/calculator/exponent" element={<ExponentCalculator />} />
            <Route path="/calculator/log" element={<LogCalculator />} />
            <Route path="/calculator/matrix" element={<MatrixCalculator />} />
            <Route path="/calculator/time" element={<TimeCalculator />} />
            <Route path="/calculator/hours" element={<HoursCalculator />} />
            <Route path="/calculator/grade" element={<GradeCalculator />} />
            <Route path="/calculator/gpa" element={<GPACalculator />} />
            <Route path="/calculator/password" element={<PasswordCalculator />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
